<!--=============================
=            THEMIFY            =
==============================-->
<template>
  <v-container>
    <base-header>
      <div slot="page-header">Icon Themify</div>
    </base-header>
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Themify</div>
          <div slot="card-body">
            <ul id="icons" class="icons icons-item">
              <li class="ti-arrow-up" data-toggle="tooltip" title="ti-arrow-up"></li>
              <li class="ti-arrow-right" data-toggle="tooltip" title="ti-arrow-right"></li>
              <li class="ti-arrow-left" data-toggle="tooltip" title="ti-arrow-left"></li>
              <li class="ti-arrow-down" data-toggle="tooltip" title="ti-arrow-down"></li>
              <li class="ti-arrows-vertical" data-toggle="tooltip" title="ti-arrows-vertical"></li>
              <li class="ti-arrows-horizontal" data-toggle="tooltip" title="ti-arrows-horizontal"></li>
              <li class="ti-angle-up" data-toggle="tooltip" title="ti-angle-up"></li>
              <li class="ti-angle-right" data-toggle="tooltip" title="ti-angle-right"></li>
              <li class="ti-angle-left" data-toggle="tooltip" title="ti-angle-left"></li>
              <li class="ti-angle-down" data-toggle="tooltip" title="ti-angle-down"></li>
              <li class="ti-angle-double-up" data-toggle="tooltip" title="ti-angle-double-up"></li>
              <li class="ti-angle-double-right" data-toggle="tooltip" title="ti-angle-double-right"></li>
              <li class="ti-angle-double-left" data-toggle="tooltip" title="ti-angle-double-left"></li>
              <li class="ti-angle-double-down" data-toggle="tooltip" title="ti-angle-double-down"></li>
              <li class="ti-move" data-toggle="tooltip" title="ti-move"></li>
              <li class="ti-fullscreen" data-toggle="tooltip" title="ti-fullscreen"></li>
              <li class="ti-arrow-top-right" data-toggle="tooltip" title="ti-arrow-top-right"></li>
              <li class="ti-arrow-top-left" data-toggle="tooltip" title="ti-arrow-top-left"></li>
              <li class="ti-arrow-circle-up" data-toggle="tooltip" title="ti-arrow-circle-up"></li>
              <li class="ti-arrow-circle-right" data-toggle="tooltip" title="ti-arrow-circle-right"></li>
              <li class="ti-arrow-circle-left" data-toggle="tooltip" title="ti-arrow-circle-left"></li>
              <li class="ti-arrow-circle-down" data-toggle="tooltip" title="ti-arrow-circle-down"></li>
              <li class="ti-arrows-corner" data-toggle="tooltip" title="ti-arrows-corner"></li>
              <li class="ti-split-v" data-toggle="tooltip" title="ti-split-v"></li>
              <li class="ti-split-v-alt" data-toggle="tooltip" title="ti-split-v-alt"></li>
              <li class="ti-split-h" data-toggle="tooltip" title="ti-split-h"></li>
              <li class="ti-hand-point-up" data-toggle="tooltip" title="ti-hand-point-up"></li>
              <li class="ti-hand-point-right" data-toggle="tooltip" title="ti-hand-point-right"></li>
              <li class="ti-hand-point-left" data-toggle="tooltip" title="ti-hand-point-left"></li>
              <li class="ti-hand-point-down" data-toggle="tooltip" title="ti-hand-point-down"></li>
              <li class="ti-back-right" data-toggle="tooltip" title="ti-back-right"></li>
              <li class="ti-back-left" data-toggle="tooltip" title="ti-back-left"></li>
              <li class="ti-exchange-vertical" data-toggle="tooltip" title="ti-exchange-vertical"></li>
              <li class="ti-wand" data-toggle="tooltip" title="ti-wand"></li>
              <li class="ti-save" data-toggle="tooltip" title="ti-save"></li>
              <li class="ti-save-alt" data-toggle="tooltip" title="ti-save-alt"></li>
              <li class="ti-direction" data-toggle="tooltip" title="ti-direction"></li>
              <li class="ti-direction-alt" data-toggle="tooltip" title="ti-direction-alt"></li>
              <li class="ti-user" data-toggle="tooltip" title="ti-user"></li>
              <li class="ti-link" data-toggle="tooltip" title="ti-link"></li>
              <li class="ti-unlink" data-toggle="tooltip" title="ti-unlink"></li>
              <li class="ti-trash" data-toggle="tooltip" title="ti-trash"></li>
              <li class="ti-target" data-toggle="tooltip" title="ti-target"></li>
              <li class="ti-tag" data-toggle="tooltip" title="ti-tag"></li>
              <li class="ti-desktop" data-toggle="tooltip" title="ti-desktop"></li>
              <li class="ti-tablet" data-toggle="tooltip" title="ti-tablet"></li>
              <li class="ti-mobile" data-toggle="tooltip" title="ti-mobile"></li>
              <li class="ti-email" data-toggle="tooltip" title="ti-email"></li>
              <li class="ti-star" data-toggle="tooltip" title="ti-star"></li>
              <li class="ti-spray" data-toggle="tooltip" title="ti-spray"></li>
              <li class="ti-signal" data-toggle="tooltip" title="ti-signal"></li>
              <li class="ti-shopping-cart" data-toggle="tooltip" title="ti-shopping-cart"></li>
              <li class="ti-shopping-cart-full" data-toggle="tooltip" title="ti-shopping-cart-full"></li>
              <li class="ti-settings" data-toggle="tooltip" title="ti-settings"></li>
              <li class="ti-search" data-toggle="tooltip" title="ti-search"></li>
              <li class="ti-zoom-in" data-toggle="tooltip" title="ti-zoom-in"></li>
              <li class="ti-zoom-out" data-toggle="tooltip" title="ti-zoom-out"></li>
              <li class="ti-cut" data-toggle="tooltip" title="ti-cut"></li>
              <li class="ti-ruler" data-toggle="tooltip" title="ti-ruler"></li>
              <li class="ti-ruler-alt-2" data-toggle="tooltip" title="ti-ruler-alt-2"></li>
              <li class="ti-ruler-pencil" data-toggle="tooltip" title="ti-ruler-pencil"></li>
              <li class="ti-ruler-alt" data-toggle="tooltip" title="ti-ruler-alt"></li>
              <li class="ti-bookmark" data-toggle="tooltip" title="ti-bookmark"></li>
              <li class="ti-bookmark-alt" data-toggle="tooltip" title="ti-bookmark-alt"></li>
              <li class="ti-reload" data-toggle="tooltip" title="ti-reload"></li>
              <li class="ti-plus" data-toggle="tooltip" title="ti-plus"></li>
              <li class="ti-minus" data-toggle="tooltip" title="ti-minus"></li>
              <li class="ti-close" data-toggle="tooltip" title="ti-close"></li>
              <li class="ti-pin" data-toggle="tooltip" title="ti-pin"></li>
              <li class="ti-pencil" data-toggle="tooltip" title="ti-pencil"></li>
              <li class="ti-pencil-alt" data-toggle="tooltip" title="ti-pencil-alt"></li>
              <li class="ti-paint-roller" data-toggle="tooltip" title="ti-paint-roller"></li>
              <li class="ti-paint-bucket" data-toggle="tooltip" title="ti-paint-bucket"></li>
              <li class="ti-na" data-toggle="tooltip" title="ti-na"></li>
              <li class="ti-medall" data-toggle="tooltip" title="ti-medall"></li>
              <li class="ti-medall-alt" data-toggle="tooltip" title="ti-medall-alt"></li>
              <li class="ti-marker" data-toggle="tooltip" title="ti-marker"></li>
              <li class="ti-marker-alt" data-toggle="tooltip" title="ti-marker-alt"></li>
              <li class="ti-lock" data-toggle="tooltip" title="ti-lock"></li>
              <li class="ti-unlock" data-toggle="tooltip" title="ti-unlock"></li>
              <li class="ti-location-arrow" data-toggle="tooltip" title="ti-location-arrow"></li>
              <li class="ti-layout" data-toggle="tooltip" title="ti-layout"></li>
              <li class="ti-layers" data-toggle="tooltip" title="ti-layers"></li>
              <li class="ti-layers-alt" data-toggle="tooltip" title="ti-layers-alt"></li>
              <li class="ti-key" data-toggle="tooltip" title="ti-key"></li>
              <li class="ti-image" data-toggle="tooltip" title="ti-image"></li>
              <li class="ti-heart" data-toggle="tooltip" title="ti-heart"></li>
              <li class="ti-heart-broken" data-toggle="tooltip" title="ti-heart-broken"></li>
              <li class="ti-hand-stop" data-toggle="tooltip" title="ti-hand-stop"></li>
              <li class="ti-hand-open" data-toggle="tooltip" title="ti-hand-open"></li>
              <li class="ti-hand-drag" data-toggle="tooltip" title="ti-hand-drag"></li>
              <li class="ti-flag" data-toggle="tooltip" title="ti-flag"></li>
              <li class="ti-flag-alt" data-toggle="tooltip" title="ti-flag-alt"></li>
              <li class="ti-flag-alt-2" data-toggle="tooltip" title="ti-flag-alt-2"></li>
              <li class="ti-eye" data-toggle="tooltip" title="ti-eye"></li>
              <li class="ti-import" data-toggle="tooltip" title="ti-import"></li>
              <li class="ti-export" data-toggle="tooltip" title="ti-export"></li>
              <li class="ti-cup" data-toggle="tooltip" title="ti-cup"></li>
              <li class="ti-crown" data-toggle="tooltip" title="ti-crown"></li>
              <li class="ti-comments" data-toggle="tooltip" title="ti-comments"></li>
              <li class="ti-comment" data-toggle="tooltip" title="ti-comment"></li>
              <li class="ti-comment-alt" data-toggle="tooltip" title="ti-comment-alt"></li>
              <li class="ti-thought" data-toggle="tooltip" title="ti-thought"></li>
              <li class="ti-clip" data-toggle="tooltip" title="ti-clip"></li>
              <li class="ti-check" data-toggle="tooltip" title="ti-check"></li>
              <li class="ti-check-box" data-toggle="tooltip" title="ti-check-box"></li>
              <li class="ti-camera" data-toggle="tooltip" title="ti-camera"></li>
              <li class="ti-announcement" data-toggle="tooltip" title="ti-announcement"></li>
              <li class="ti-brush" data-toggle="tooltip" title="ti-brush"></li>
              <li class="ti-brush-alt" data-toggle="tooltip" title="ti-brush-alt"></li>
              <li class="ti-palette" data-toggle="tooltip" title="ti-palette"></li>
              <li class="ti-briefcase" data-toggle="tooltip" title="ti-briefcase"></li>
              <li class="ti-bolt" data-toggle="tooltip" title="ti-bolt"></li>
              <li class="ti-bolt-alt" data-toggle="tooltip" title="ti-bolt-alt"></li>
              <li class="ti-blackboard" data-toggle="tooltip" title="ti-blackboard"></li>
              <li class="ti-bag" data-toggle="tooltip" title="ti-bag"></li>
              <li class="ti-world" data-toggle="tooltip" title="ti-world"></li>
              <li class="ti-wheelchair" data-toggle="tooltip" title="ti-wheelchair"></li>
              <li class="ti-car" data-toggle="tooltip" title="ti-car"></li>
              <li class="ti-truck" data-toggle="tooltip" title="ti-truck"></li>
              <li class="ti-timer" data-toggle="tooltip" title="ti-timer"></li>
              <li class="ti-ticket" data-toggle="tooltip" title="ti-ticket"></li>
              <li class="ti-thumb-up" data-toggle="tooltip" title="ti-thumb-up"></li>
              <li class="ti-thumb-down" data-toggle="tooltip" title="ti-thumb-down"></li>
              <li class="ti-stats-up" data-toggle="tooltip" title="ti-stats-up"></li>
              <li class="ti-stats-down" data-toggle="tooltip" title="ti-stats-down"></li>
              <li class="ti-shine" data-toggle="tooltip" title="ti-shine"></li>
              <li class="ti-shift-right" data-toggle="tooltip" title="ti-shift-right"></li>
              <li class="ti-shift-left" data-toggle="tooltip" title="ti-shift-left"></li>
              <li class="ti-shift-right-alt" data-toggle="tooltip" title="ti-shift-right-alt"></li>
              <li class="ti-shift-left-alt" data-toggle="tooltip" title="ti-shift-left-alt"></li>
              <li class="ti-shield" data-toggle="tooltip" title="ti-shield"></li>
              <li class="ti-notepad" data-toggle="tooltip" title="ti-notepad"></li>
              <li class="ti-server" data-toggle="tooltip" title="ti-server"></li>
              <li class="ti-pulse" data-toggle="tooltip" title="ti-pulse"></li>
              <li class="ti-printer" data-toggle="tooltip" title="ti-printer"></li>
              <li class="ti-power-off" data-toggle="tooltip" title="ti-power-off"></li>
              <li class="ti-plug" data-toggle="tooltip" title="ti-plug"></li>
              <li class="ti-pie-chart" data-toggle="tooltip" title="ti-pie-chart"></li>
              <li class="ti-panel" data-toggle="tooltip" title="ti-panel"></li>
              <li class="ti-package" data-toggle="tooltip" title="ti-package"></li>
              <li class="ti-music" data-toggle="tooltip" title="ti-music"></li>
              <li class="ti-music-alt" data-toggle="tooltip" title="ti-music-alt"></li>
              <li class="ti-mouse" data-toggle="tooltip" title="ti-mouse"></li>
              <li class="ti-mouse-alt" data-toggle="tooltip" title="ti-mouse-alt"></li>
              <li class="ti-money" data-toggle="tooltip" title="ti-money"></li>
              <li class="ti-microphone" data-toggle="tooltip" title="ti-microphone"></li>
              <li class="ti-menu" data-toggle="tooltip" title="ti-menu"></li>
              <li class="ti-menu-alt" data-toggle="tooltip" title="ti-menu-alt"></li>
              <li class="ti-map" data-toggle="tooltip" title="ti-map"></li>
              <li class="ti-map-alt" data-toggle="tooltip" title="ti-map-alt"></li>
              <li class="ti-location-pin" data-toggle="tooltip" title="ti-location-pin"></li>
              <li class="ti-light-bulb" data-toggle="tooltip" title="ti-light-bulb"></li>
              <li class="ti-info" data-toggle="tooltip" title="ti-info"></li>
              <li class="ti-infinite" data-toggle="tooltip" title="ti-infinite"></li>
              <li class="ti-id-badge" data-toggle="tooltip" title="ti-id-badge"></li>
              <li class="ti-hummer" data-toggle="tooltip" title="ti-hummer"></li>
              <li class="ti-home" data-toggle="tooltip" title="ti-home"></li>
              <li class="ti-help" data-toggle="tooltip" title="ti-help"></li>
              <li class="ti-headphone" data-toggle="tooltip" title="ti-headphone"></li>
              <li class="ti-harddrives" data-toggle="tooltip" title="ti-harddrives"></li>
              <li class="ti-harddrive" data-toggle="tooltip" title="ti-harddrive"></li>
              <li class="ti-gift" data-toggle="tooltip" title="ti-gift"></li>
              <li class="ti-game" data-toggle="tooltip" title="ti-game"></li>
              <li class="ti-filter" data-toggle="tooltip" title="ti-filter"></li>
              <li class="ti-files" data-toggle="tooltip" title="ti-files"></li>
              <li class="ti-file" data-toggle="tooltip" title="ti-file"></li>
              <li class="ti-zip" data-toggle="tooltip" title="ti-zip"></li>
              <li class="ti-folder" data-toggle="tooltip" title="ti-folder"></li>
              <li class="ti-envelope" data-toggle="tooltip" title="ti-envelope"></li>
              <li class="ti-dashboard" data-toggle="tooltip" title="ti-dashboard"></li>
              <li class="ti-cloud" data-toggle="tooltip" title="ti-cloud"></li>
              <li class="ti-cloud-up" data-toggle="tooltip" title="ti-cloud-up"></li>
              <li class="ti-cloud-down" data-toggle="tooltip" title="ti-cloud-down"></li>
              <li class="ti-clipboard" data-toggle="tooltip" title="ti-clipboard"></li>
              <li class="ti-calendar" data-toggle="tooltip" title="ti-calendar"></li>
              <li class="ti-book" data-toggle="tooltip" title="ti-book"></li>
              <li class="ti-bell" data-toggle="tooltip" title="ti-bell"></li>
              <li class="ti-basketball" data-toggle="tooltip" title="ti-basketball"></li>
              <li class="ti-bar-chart" data-toggle="tooltip" title="ti-bar-chart"></li>
              <li class="ti-bar-chart-alt" data-toggle="tooltip" title="ti-bar-chart-alt"></li>
              <li class="ti-archive" data-toggle="tooltip" title="ti-archive"></li>
              <li class="ti-anchor" data-toggle="tooltip" title="ti-anchor"></li>
              <li class="ti-alert" data-toggle="tooltip" title="ti-alert"></li>
              <li class="ti-alarm-clock" data-toggle="tooltip" title="ti-alarm-clock"></li>
              <li class="ti-agenda" data-toggle="tooltip" title="ti-agenda"></li>
              <li class="ti-write" data-toggle="tooltip" title="ti-write"></li>
              <li class="ti-wallet" data-toggle="tooltip" title="ti-wallet"></li>
              <li class="ti-video-clapper" data-toggle="tooltip" title="ti-video-clapper"></li>
              <li class="ti-video-camera" data-toggle="tooltip" title="ti-video-camera"></li>
              <li class="ti-vector" data-toggle="tooltip" title="ti-vector"></li>
              <li class="ti-support" data-toggle="tooltip" title="ti-support"></li>
              <li class="ti-stamp" data-toggle="tooltip" title="ti-stamp"></li>
              <li class="ti-slice" data-toggle="tooltip" title="ti-slice"></li>
              <li class="ti-shortcode" data-toggle="tooltip" title="ti-shortcode"></li>
              <li class="ti-receipt" data-toggle="tooltip" title="ti-receipt"></li>
              <li class="ti-pin2" data-toggle="tooltip" title="ti-pin2"></li>
              <li class="ti-pin-alt" data-toggle="tooltip" title="ti-pin-alt"></li>
              <li class="ti-pencil-alt2" data-toggle="tooltip" title="ti-pencil-alt2"></li>
              <li class="ti-eraser" data-toggle="tooltip" title="ti-eraser"></li>
              <li class="ti-more" data-toggle="tooltip" title="ti-more"></li>
              <li class="ti-more-alt" data-toggle="tooltip" title="ti-more-alt"></li>
              <li class="ti-microphone-alt" data-toggle="tooltip" title="ti-microphone-alt"></li>
              <li class="ti-magnet" data-toggle="tooltip" title="ti-magnet"></li>
              <li class="ti-line-double" data-toggle="tooltip" title="ti-line-double"></li>
              <li class="ti-line-dotted" data-toggle="tooltip" title="ti-line-dotted"></li>
              <li class="ti-line-dashed" data-toggle="tooltip" title="ti-line-dashed"></li>
              <li class="ti-ink-pen" data-toggle="tooltip" title="ti-ink-pen"></li>
              <li class="ti-info-alt" data-toggle="tooltip" title="ti-info-alt"></li>
              <li class="ti-help-alt" data-toggle="tooltip" title="ti-help-alt"></li>
              <li class="ti-headphone-alt" data-toggle="tooltip" title="ti-headphone-alt"></li>
              <li class="ti-gallery" data-toggle="tooltip" title="ti-gallery"></li>
              <li class="ti-face-smile" data-toggle="tooltip" title="ti-face-smile"></li>
              <li class="ti-face-sad" data-toggle="tooltip" title="ti-face-sad"></li>
              <li class="ti-credit-card" data-toggle="tooltip" title="ti-credit-card"></li>
              <li class="ti-comments-smiley" data-toggle="tooltip" title="ti-comments-smiley"></li>
              <li class="ti-time" data-toggle="tooltip" title="ti-time"></li>
              <li class="ti-share" data-toggle="tooltip" title="ti-share"></li>
              <li class="ti-share-alt" data-toggle="tooltip" title="ti-share-alt"></li>
              <li class="ti-rocket" data-toggle="tooltip" title="ti-rocket"></li>
              <li class="ti-new-window" data-toggle="tooltip" title="ti-new-window"></li>
              <li class="ti-rss" data-toggle="tooltip" title="ti-rss"></li>
              <li class="ti-rss-alt" data-toggle="tooltip" title="ti-rss-alt"></li>
            </ul>
          </div>
        </base-card>
        <!-- end buttons -->
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import BaseCard from "../../layout/Base/BaseCard.vue";
import BaseHeader from "../../layout/Base/BaseHeader.vue";
export default {
  components: {
    BaseCard,
    BaseHeader
  },
  data() {
    return {
      icons: [
        {
          name: "ti-arrow-up"
        },

        {
          name: "ti-arrow-right"
        },

        {
          name: "ti-arrow-left"
        },

        {
          name: "ti-arrow-down"
        },

        {
          name: "ti-arrows-vertical"
        },

        {
          name: "ti-arrows-horizontal"
        },

        {
          name: "ti-angle-up"
        },

        {
          name: "ti-angle-right"
        },

        {
          name: "ti-angle-left"
        },

        {
          name: "ti-angle-down"
        },

        {
          name: "ti-angle-double-up"
        },

        {
          name: "ti-angle-double-right"
        },

        {
          name: "ti-angle-double-left"
        },

        {
          name: "ti-angle-double-down"
        },

        {
          name: "ti-move"
        },

        {
          name: "ti-fullscreen"
        },

        {
          name: "ti-arrow-top-right"
        },

        {
          name: "ti-arrow-top-left"
        },

        {
          name: "ti-arrow-circle-up"
        },

        {
          name: "ti-arrow-circle-right"
        },

        {
          name: "ti-arrow-circle-left"
        },

        {
          name: "ti-arrow-circle-down"
        },

        {
          name: "ti-arrows-corner"
        },

        {
          name: "ti-split-v"
        },

        {
          name: "ti-split-v-alt"
        },

        {
          name: "ti-split-h"
        },

        {
          name: "ti-hand-point-up"
        },

        {
          name: "ti-hand-point-right"
        },

        {
          name: "ti-hand-point-left"
        },

        {
          name: "ti-hand-point-down"
        },

        {
          name: "ti-back-right"
        },

        {
          name: "ti-back-left"
        },

        {
          name: "ti-exchange-vertical"
        },

        {
          name: "ti-wand"
        },

        {
          name: "ti-save"
        },

        {
          name: "ti-save-alt"
        },

        {
          name: "ti-direction"
        },

        {
          name: "ti-direction-alt"
        },

        {
          name: "ti-user"
        },

        {
          name: "ti-link"
        },

        {
          name: "ti-unlink"
        },

        {
          name: "ti-trash"
        },

        {
          name: "ti-target"
        },

        {
          name: "ti-tag"
        },

        {
          name: "ti-desktop"
        },

        {
          name: "ti-tablet"
        },

        {
          name: "ti-mobile"
        },

        {
          name: "ti-email"
        },

        {
          name: "ti-star"
        },

        {
          name: "ti-spray"
        },

        {
          name: "ti-signal"
        },

        {
          name: "ti-shopping-cart"
        },

        {
          name: "ti-shopping-cart-full"
        },

        {
          name: "ti-settings"
        },

        {
          name: "ti-search"
        },

        {
          name: "ti-zoom-in"
        },

        {
          name: "ti-zoom-out"
        },

        {
          name: "ti-cut"
        },

        {
          name: "ti-ruler"
        },

        {
          name: "ti-ruler-alt-2"
        },

        {
          name: "ti-ruler-pencil"
        },

        {
          name: "ti-ruler-alt"
        },

        {
          name: "ti-bookmark"
        },

        {
          name: "ti-bookmark-alt"
        },

        {
          name: "ti-reload"
        },

        {
          name: "ti-plus"
        },

        {
          name: "ti-minus"
        },

        {
          name: "ti-close"
        },

        {
          name: "ti-pin"
        },

        {
          name: "ti-pencil"
        },

        {
          name: "ti-pencil-alt"
        },

        {
          name: "ti-paint-roller"
        },

        {
          name: "ti-paint-bucket"
        },

        {
          name: "ti-na"
        },

        {
          name: "ti-medall"
        },

        {
          name: "ti-medall-alt"
        },

        {
          name: "ti-marker"
        },

        {
          name: "ti-marker-alt"
        },

        {
          name: "ti-lock"
        },

        {
          name: "ti-unlock"
        },

        {
          name: "ti-location-arrow"
        },

        {
          name: "ti-layout"
        },

        {
          name: "ti-layers"
        },

        {
          name: "ti-layers-alt"
        },

        {
          name: "ti-key"
        },

        {
          name: "ti-image"
        },

        {
          name: "ti-heart"
        },

        {
          name: "ti-heart-broken"
        },

        {
          name: "ti-hand-stop"
        },

        {
          name: "ti-hand-open"
        },

        {
          name: "ti-hand-drag"
        },

        {
          name: "ti-flag"
        },

        {
          name: "ti-flag-alt"
        },

        {
          name: "ti-flag-alt-2"
        },

        {
          name: "ti-eye"
        },

        {
          name: "ti-import"
        },

        {
          name: "ti-export"
        },

        {
          name: "ti-cup"
        },

        {
          name: "ti-crown"
        },

        {
          name: "ti-comments"
        },

        {
          name: "ti-comment"
        },

        {
          name: "ti-comment-alt"
        },

        {
          name: "ti-thought"
        },

        {
          name: "ti-clip"
        },

        {
          name: "ti-check"
        },

        {
          name: "ti-check-box"
        },

        {
          name: "ti-camera"
        },

        {
          name: "ti-announcement"
        },

        {
          name: "ti-brush"
        },

        {
          name: "ti-brush-alt"
        },

        {
          name: "ti-palette"
        },

        {
          name: "ti-briefcase"
        },

        {
          name: "ti-bolt"
        },

        {
          name: "ti-bolt-alt"
        },

        {
          name: "ti-blackboard"
        },

        {
          name: "ti-bag"
        },

        {
          name: "ti-world"
        },

        {
          name: "ti-wheelchair"
        },

        {
          name: "ti-car"
        },

        {
          name: "ti-truck"
        },

        {
          name: "ti-timer"
        },

        {
          name: "ti-ticket"
        },

        {
          name: "ti-thumb-up"
        },

        {
          name: "ti-thumb-down"
        },

        {
          name: "ti-stats-up"
        },

        {
          name: "ti-stats-down"
        },

        {
          name: "ti-shine"
        },

        {
          name: "ti-shift-right"
        },

        {
          name: "ti-shift-left"
        },

        {
          name: "ti-shift-right-alt"
        },

        {
          name: "ti-shift-left-alt"
        },

        {
          name: "ti-shield"
        },

        {
          name: "ti-notepad"
        },

        {
          name: "ti-server"
        },

        {
          name: "ti-pulse"
        },

        {
          name: "ti-printer"
        },

        {
          name: "ti-power-off"
        },

        {
          name: "ti-plug"
        },

        {
          name: "ti-pie-chart"
        },

        {
          name: "ti-panel"
        },

        {
          name: "ti-package"
        },

        {
          name: "ti-music"
        },

        {
          name: "ti-music-alt"
        },

        {
          name: "ti-mouse"
        },

        {
          name: "ti-mouse-alt"
        },

        {
          name: "ti-money"
        },

        {
          name: "ti-microphone"
        },

        {
          name: "ti-menu"
        },

        {
          name: "ti-menu-alt"
        },

        {
          name: "ti-map"
        },

        {
          name: "ti-map-alt"
        },

        {
          name: "ti-location-pin"
        },

        {
          name: "ti-light-bulb"
        },

        {
          name: "ti-info"
        },

        {
          name: "ti-infinite"
        },

        {
          name: "ti-id-badge"
        },

        {
          name: "ti-hummer"
        },

        {
          name: "ti-home"
        },

        {
          name: "ti-help"
        },

        {
          name: "ti-headphone"
        },

        {
          name: "ti-harddrives"
        },

        {
          name: "ti-harddrive"
        },

        {
          name: "ti-gift"
        },

        {
          name: "ti-game"
        },

        {
          name: "ti-filter"
        },

        {
          name: "ti-files"
        },

        {
          name: "ti-file"
        },

        {
          name: "ti-zip"
        },

        {
          name: "ti-folder"
        },

        {
          name: "ti-envelope"
        },

        {
          name: "ti-dashboard"
        },

        {
          name: "ti-cloud"
        },

        {
          name: "ti-cloud-up"
        },

        {
          name: "ti-cloud-down"
        },

        {
          name: "ti-clipboard"
        },

        {
          name: "ti-calendar"
        },

        {
          name: "ti-book"
        },

        {
          name: "ti-bell"
        },

        {
          name: "ti-basketball"
        },

        {
          name: "ti-bar-chart"
        },

        {
          name: "ti-bar-chart-alt"
        },

        {
          name: "ti-archive"
        },

        {
          name: "ti-anchor"
        },

        {
          name: "ti-alert"
        },

        {
          name: "ti-alarm-clock"
        },

        {
          name: "ti-agenda"
        },

        {
          name: "ti-write"
        },

        {
          name: "ti-wallet"
        },

        {
          name: "ti-video-clapper"
        },

        {
          name: "ti-video-camera"
        },

        {
          name: "ti-vector"
        },

        {
          name: "ti-support"
        },

        {
          name: "ti-stamp"
        },

        {
          name: "ti-slice"
        },

        {
          name: "ti-shortcode"
        },

        {
          name: "ti-receipt"
        },

        {
          name: "ti-pin2"
        },

        {
          name: "ti-pin-alt"
        },

        {
          name: "ti-pencil-alt2"
        },

        {
          name: "ti-eraser"
        },

        {
          name: "ti-more"
        },

        {
          name: "ti-more-alt"
        },

        {
          name: "ti-microphone-alt"
        },

        {
          name: "ti-magnet"
        },

        {
          name: "ti-line-double"
        },

        {
          name: "ti-line-dotted"
        },

        {
          name: "ti-line-dashed"
        },

        {
          name: "ti-ink-pen"
        },

        {
          name: "ti-info-alt"
        },

        {
          name: "ti-help-alt"
        },

        {
          name: "ti-headphone-alt"
        },

        {
          name: "ti-gallery"
        },

        {
          name: "ti-face-smile"
        },

        {
          name: "ti-face-sad"
        },

        {
          name: "ti-credit-card"
        },

        {
          name: "ti-comments-smiley"
        },

        {
          name: "ti-time"
        },

        {
          name: "ti-share"
        },

        {
          name: "ti-share-alt"
        },

        {
          name: "ti-rocket"
        },

        {
          name: "ti-new-window"
        },

        {
          name: "ti-rss"
        },

        {
          name: "ti-rss-alt"
        }
      ]
    };
  }
};
</script>


<style scoped>
.icons-item {
  color: #ccc;
  padding: 0;
  margin: 0;
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.icons-item li {
  width: 120px;
  height: 120px;
  font-size: 20px;
  line-height: 3;
  margin: 0px;
  list-style: none;
  text-align: center;
  border-radius: 3px;
  border-radius: 4px;
  position: relative;
  border: 1px solid #f0f0f2;
  cursor: pointer;
}

.icons {
  padding: 10;
  margin: 10;
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.icons li {
  width: 60px;
  height: 60px;
  font-size: 20px;
  line-height: 3;
  list-style: none;
  text-align: center;
  border-radius: 3px;
  border-radius: 4px;
  position: relative;
  border: 1px solid #ccc;
  cursor: pointer;
  color: gray;
}

.icons li:hover {
  opacity: 0.8;
}

.icons li .icon-name {
  display: none;
}

.icons-list div {
  cursor: pointer;
  line-height: 45px;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
  overflow: hidden;
  text-align: center;
}

.icons-list i {
  font-size: 22px;
  line-height: 30px;
  display: block;
}

.button-examples {
  margin-left: -5px;
  margin-bottom: -10px;
}

.button-examples .btn {
  margin-bottom: 10px;
  margin-left: 5px;
}

/*-- end ionicons--- */
</style>
<!--====  End of THEMIFY  ====-->